import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { Avatar, Button, Form, Tooltip } from 'antd';
import React, { ReactElement, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState } from '../../../store';
import { setSelectedItem, updateDropdownSearchFilter } from '../../../store/actions/inPatientAction';
import { PayerInitialState } from '../../../store/models/payerListModel';
import './scrollableMenu.less';

const ClaimCountHeader = (props: any): ReactElement => {
  const {
    totalClaimCount, filters, selectedItem, resetFilter,
  } = props;
  const dispatch = useDispatch();
  const [searchForm] = Form.useForm();
  const menuRef = React.useRef<HTMLDivElement>(null);
  const [payerItems, setPayerItems] = useState<{ key: string; value: number[] }[]>([]);
  const { allPayers } = useSelector((state: RootState): PayerInitialState => state.payerList);

  const menuItems = allPayers?.map((item: any): any => ({
    id: item.id,
    name: item.name,
    logo: item?.payerIcon,
    productCode: item.productCode,
    uniqueIdentifier: item.uniqueIdentifier,
    isGovtScheme: item.isGovtScheme,
  }));

  useEffect((): any => {
    const initialPayerItems = [{ key: 'payerId', value: [] }];
    setPayerItems(initialPayerItems);
  }, []);

  useEffect((): any => {
    if (filters?.payerId?.length === 0 && selectedItem) {
      dispatch(setSelectedItem(''));
    }
  }, [filters]);

  useEffect((): any => {
    if (menuRef.current && selectedItem) {
      searchForm.setFieldsValue({ payerName: selectedItem });
      const selectedItemRef = document.getElementById(`menu-item-${selectedItem}`);
      if (selectedItemRef) {
        const rect = selectedItemRef.getBoundingClientRect();
        const offsetLeft = rect.left - menuRef.current.getBoundingClientRect().left;
        menuRef.current.scrollTo({ left: offsetLeft, behavior: 'smooth' });
      }
    }
  }, [selectedItem]);

  const handleItemClick = (itemId: number, itemProductCode: any, uniqueIdentifier: any, isGovtScheme: any): any => {
    if (selectedItem === itemId || selectedItem === uniqueIdentifier) {
      resetFilter();
    } else {
      const items = itemProductCode === null ? itemId : uniqueIdentifier;
      dispatch(setSelectedItem(items));
      dispatch(updateDropdownSearchFilter({ payerId: isGovtScheme ? String(uniqueIdentifier) : String(itemId) }));
    }
    const updatedPayerItems = payerItems.map((item: any): any => ({
      ...item,
      value: item.key === 'payerId' ? [isGovtScheme ? String(uniqueIdentifier) : String(itemId)] : [],
    }));
    setPayerItems(updatedPayerItems);

    const selectedItemRef = document.getElementById(`menu-item-${itemId}`);
    if (selectedItemRef) {
      const rect = selectedItemRef.getBoundingClientRect();
      if (rect.left < 0 || rect.right > window.innerWidth) {
        selectedItemRef.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
      }
    }
  };
  const getCountForItem = (itemId: number, itemProductCode?: any): number | undefined => {
    const countItem = totalClaimCount?.find((count: any): any =>
      (count?.productCode === null) ? (count?.payerID === itemId) : (count?.productCode === itemProductCode));
    return countItem ? countItem.count : undefined;
  };
  const getRandomColor = (): any => {
    const randomColor = '#' + Math.floor(Math.random() * 16777215).toString(16);
    return randomColor;
  };
  const handleScrollLeft = (): any => {
    if (menuRef.current) {
      menuRef.current.scrollLeft -= 100;
    }
  };
  const handleScrollRight = (): any => {
    if (menuRef.current) {
      menuRef.current.scrollLeft += 100;
    }
  };

  return (
    <><Button className="arrow-button arrow-button-box" onClick={handleScrollLeft} type="text">
      <LeftOutlined />
    </Button>
    <Form.Item className="width-scroll">
      <div className="scrollable-menu">
        <div className="menu-container" ref={menuRef}>
          {menuItems.map((item: any): any => {
            const initials = item.name
              .split(' ')
              .slice(0, 2)
              .map((word: any): any => word.charAt(0).toUpperCase())
              .join('');
            const avatarStyle = item.logo
              ? {
                backgroundImage: `url(${item.logo})`,
                backgroundSize: '40px',
                backgroundPosition: 'center',
              }
              : { backgroundColor: getRandomColor() };
            return (
              <div
                key={item.uniqueIdentifier}
                id={`menu-item-${item.id}`}
                className={`menu-item ${(item?.productCode === null ? selectedItem === item.id : selectedItem === item.uniqueIdentifier) ? 'active' : ''}`}
                onClick={(): any => handleItemClick(item.id, item?.productCode, item?.uniqueIdentifier, item?.isGovtScheme)}
              >
                <span className={`menu-item ${(item?.productCode === null ? selectedItem === item.id : selectedItem === item.uniqueIdentifier) ? 'active-ele' : ''}`}>
                  <Tooltip title={item.name}>
                    <Avatar className="avatar-initial" style={avatarStyle}>
                      {!item.logo && initials}
                    </Avatar>
                  </Tooltip>
                  <span className="item-count">{`${getCountForItem(item.id, item.productCode) || 0} Claims`}</span>
                </span>
              </div>
            );
          },
          )}
        </div>
      </div>
    </Form.Item>
      <Button className="arrow-button arrow-button-box" onClick={handleScrollRight} type="text">
        <RightOutlined />
      </Button></>
  );
};

export default ClaimCountHeader;
